import { GlobalType } from "../types.store";

export const globalSelector = (state : {global : GlobalType}) => state.global